export const CustomCard = ({ title, children }) => (
    <div className="border border-gray-300 rounded bg-white text-sm shadow-sm p-4">
        {title && <h3 className="text-lg font-semibold mb-3 text-gray-800">{title}</h3>}
        {children}
    </div>
);